import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

import { breakpoints } from '@shared/constants';

export const ReportListWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    margin-top: 24px;

    @media (max-width: ${breakpoints.lg}px) {
        padding-left: 25px;
    }

    @media (max-width: ${breakpoints.sm}px) {
        margin-bottom: 30px;
    }

    @media (max-width: ${breakpoints.xs}px) {
        padding-left: 0;
    }
`;

export const ReportListHeader = styled.div`
    display: flex;
    padding: 18px 24px;

    @media (max-width: ${breakpoints.sm}px) {
        padding: 18px 16px;
    }
`;

const reportListHeaderCellCss = css`
    ${({ theme: { fontSize, fontWeight, palette } }) => css`
        color: ${palette.neutral.black};
        font-size: ${fontSize[12]}px;
        font-weight: ${fontWeight.bold};
        margin-right: 20px;
    `}
`;

export const ReportCell = styled.div`
    flex: 1;
    min-width: 130px;
    ${reportListHeaderCellCss};

    @media (max-width: ${breakpoints.sm}px) {
        min-width: 100px;
    }
`;

export const StatusCell = styled.div`
    flex: 1;
    ${reportListHeaderCellCss};
`;

export const MessageCell = styled.div`
    flex: 3;
    ${reportListHeaderCellCss};

    @media (max-width: ${breakpoints.xs}px) {
        flex: 1;
    }
`;

export const DateCell = styled.div`
    flex: 1;
    ${reportListHeaderCellCss};

    @media (max-width: ${breakpoints.md}px) {
        display: none;
    }
`;

export const ReportListBody = styled.div``;

export const ButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin: 32px 0;
`;

export const ReportListNoItems = styled(Typography.TextH3_24_34)`
    ${({ theme: { fontWeight, palette } }) => css`
        color: ${palette.text.assistive};
        font-weight: ${fontWeight.bold};
        padding: 70px 0 50px;
        text-align: center;
    `}
`;
